<script lang="ts">
    import { appManager } from "../../AppManagerStore";
    import OrganizationRow from "./OrganizationRow.svelte";
    import NewOrganizationModal from "./NewOrganizationModal.svelte";
    import type {
        UserData,
        UserOrganizationRoleData,
    } from "@anyways-open/identity-api-client";
    import { onMount } from "svelte";

    export let data: UserData;
    let roles: UserOrganizationRoleData[] = [];

    onMount(async () => {
        await load();
    });

    let newOrgModalOpen = false;
    const newOrganization = () => {
        newOrgModalOpen = true;
    };

    $: if (!newOrgModalOpen) {
        reload().then();
    }

    const reload = async () => {
        await load();
    };

    const load = async () => {
        data = await $appManager.IdentityApi.getCurrentUser();

        roles = data.roles ?? [];
    };
</script>

<NewOrganizationModal open={newOrgModalOpen} />

<div class="card card-bleed shadow-light-lg mb-6">
    <div class="card-header">
        <div class="row align-items-center">
            <div class="col">
                <h4 class="mb-0">Organizations</h4>
            </div>
            <div class="col-auto">
                <button
                    class="btn btn-xs btn-primary"
                    on:click={() => newOrganization()}>
                    New organization
                </button>
            </div>
        </div>
    </div>
    <div class="card-body">
        <div class="list-group list-group-flush">
            {#if roles.length == 0}
                You are not a member of any organization.
            {/if}
            {#each roles as organizationRole}
                <OrganizationRow data={organizationRole} />
            {/each}
        </div>
    </div>
</div>
